import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './Banner.css';

const Banner = ({ banner, onDismiss }) => {
  const { id, message, type, actions } = banner;
  const { t } = useTranslation();

  return (
    <div className={`banner banner-${type}`}>
      <div className="banner-message">{typeof message === 'string' ? <span dangerouslySetInnerHTML={{ __html: message }} /> : message}</div>
      <div className="banner-actions">
        {actions &&
          actions.map((action, index) => (
            <button
              key={index}
              onClick={() => {
                action.onClick();
              }}
              className="banner-action-button"
            >
              {action.text}
            </button>
          ))}
      </div>
      <button onClick={() => onDismiss(id)} className="banner-dismiss-button" aria-label={t('dismiss_button_label')}>
        &times;
      </button>
    </div>
  );
};

Banner.propTypes = {
  banner: PropTypes.shape({
    id: PropTypes.string.isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    type: PropTypes.oneOf(['info', 'warning', 'error', 'success']).isRequired,
    actions: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string.isRequired, onClick: PropTypes.func.isRequired })),
  }).isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default Banner;
